import { render, staticRenderFns } from "./ProjectAssetsByReviewerList.vue?vue&type=template&id=a5e79c1e"
import script from "./ProjectAssetsByReviewerList.vue?vue&type=script&lang=js"
export * from "./ProjectAssetsByReviewerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports